"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var resizeChange = function resizeChange(handler) {
  window.addEventListener('resize', function (event) {
    handler(event);
  }, false);
};
var _default = exports["default"] = resizeChange;